import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { SettingsPage } from "@/pages/settings/SettingsPage";
import { SettingsPageSkeleton } from "@/pages/settings/SettingsPageSkeleton";

const SettingsSearchSchema = z.object({
	tab: z
		.enum(["account", "security", "subscription", "billing"])
		.default("account"),
});

export const Route = createFileRoute("/_app/settings")({
	validateSearch: SettingsSearchSchema,
	head: () => ({
		meta: [{ title: "Settings - Biteasy" }],
	}),
	pendingComponent: SettingsPageSkeleton,
	component: SettingsPage,
});
